import { orderBy } from 'lodash'
import components from '../../components'

import { WIDTH as WIDTHPdf, GAP, PADDING } from '../../constants'

const notApplicableQuestions = ({
  pdf,
  date,
  questionnairesWithQuestionNotApplicable,
}) => {
  const WIDTH = WIDTHPdf(pdf) - PADDING * 2
  const columnStyles = {
    0: {
      cellWidth: 0.8 * WIDTH,
      halign: 'left',
    },
    1: {
      cellWidth: 0.2 * WIDTH,
      halign: 'center',
    },
  }

  pdf.addPage()
  components.lineWithDate(pdf, date)
  components.subtitle(pdf, 'Questões optadas em "Não se aplica".', GAP)

  const generateRows = (questionsNotApplicable) => {
    const array = questionsNotApplicable.map((question) => [
      question.question,
      question.answer,
    ])

    array.unshift(['Questão', 'Resposta'])
    return array
  }

  orderBy(questionnairesWithQuestionNotApplicable, 'name').forEach(
    (questionnaire, index) => {
      let startY = index === 0 ? GAP * 1.25 : pdf.autoTable.previous.finalY + 16

      components.table(
        pdf,
        [[questionnaire.name, null]],
        generateRows(questionnaire.questionsNotApplicable),
        startY,
        0.2,
        PADDING,
        false,
        columnStyles,
      )
    },
  )
}

export default notApplicableQuestions
